// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/react-scripts/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./fonts.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/react-scripts/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./animate.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@100;200;300;500;600;700;900&display=swap);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper-card-publications {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap; }
  @media (max-width: 325px) {
    .wrapper-card-publications {
      justify-content: center; } }

a.card-anchor_item {
  text-decoration: none; }

.custom-card-component {
  position: relative;
  flex: 1 1 250px;
  overflow: hidden;
  min-width: 250px;
  max-width: 350px;
  background-color: #fff;
  height: 250px;
  max-height: 250px;
  border-radius: 5px;
  cursor: pointer;
  transform: scale(1);
  animation: scale-in 0.5s cubic-bezier(0.07, -0.01, 0, 1.19);
  animation-fill-mode: both;
  transform-style: preserve-3d;
  transition: all 0.2s cubic-bezier(0.075, 0.82, 0.165, 1); }
  @media (max-width: 325px) {
    .custom-card-component {
      flex: initial;
      width: 95%; } }
  .custom-card-component:hover {
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
    height: auto;
    transform-origin: center;
    z-index: 1; }
  .custom-card-component:hover > .custom-card-component__edit-fav {
    left: 15px;
    transform: scale(1.05) rotate(0deg); }
  .custom-card-component:hover > .custom-card-component__card-footer {
    bottom: 0;
    opacity: 1; }
  .custom-card-component:hover .custom-card-component__card-body__img > img {
    width: 95%;
    object-position: top; }
  .custom-card-component__edit-fav {
    width: 40px;
    height: 33px;
    background-color: #cecece;
    font-size: 10px;
    vertical-align: middle;
    border: none;
    position: absolute;
    top: 25%;
    transform: rotate(180deg);
    margin: auto 0;
    left: -50px;
    box-shadow: 0 0.5rem 1rem #00000057;
    border-radius: 5px;
    transition: all .2s ease-out;
    z-index: 2; }
    .custom-card-component__edit-fav.isFav {
      background-color: #3ba338; }
      .custom-card-component__edit-fav.isFav svg {
        color: #fff !important; }
    .custom-card-component__edit-fav__loader {
      font-size: 16px;
      position: relative;
      top: 1px;
      color: #565252;
      animation: loader 1.5s linear infinite; }

@keyframes loader {
  0% {
    transform: rotate(0deg); }
  100% {
    transform: rotate(360deg); } }
  .custom-card-component__card-header {
    padding: 10px 15px 10px 15px; }
    .custom-card-component__card-header__title {
      color: #2d572c;
      font-size: 14px;
      font-weight: 800; }
    .custom-card-component__card-header__price {
      color: #000;
      font-size: 13px; }
  .custom-card-component__card-body {
    padding: 0px 0px 10px 0; }
    .custom-card-component__card-body__img {
      position: relative;
      background-position: center;
      width: 100%;
      height: 200px; }
      .custom-card-component__card-body__img .overlay-blur {
        width: 100%;
        height: 100%;
        position: absolute;
        -webkit-backdrop-filter: blur(3px);
                backdrop-filter: blur(3px); }
      .custom-card-component__card-body__img img {
        transition: all .2s ease-out;
        position: relative;
        z-index: 1;
        object-fit: scale-down;
        width: 85%;
        object-position: center;
        height: 100%; }
  .custom-card-component__card-footer {
    padding: 10px 10px 10px 10px;
    position: absolute;
    z-index: 2;
    bottom: -60px;
    left: 0;
    right: 0;
    margin: 0 auto;
    transition: all .2s ease-out;
    background-color: #fff;
    opacity: 0; }
  .custom-card-component__concess-footer {
    background-color: #656565 !important; }

@keyframes scale-in {
  0% {
    opacity: 0;
    transform: scale(0.9); }
  100% {
    opacity: 1;
    transform: scale(1); } }

.input-search {
  position: relative;
  min-width: 230px;
  width: 100%;
  margin: 0 auto;
  border-radius: 5px; }
  .input-search__input {
    width: 100%;
    border: none;
    padding: 15px 38px 3px 15px;
    font-weight: 400;
    background: #fff;
    height: 40px;
    color: #585858;
    border-radius: 5px;
    outline: none;
    min-width: 200px;
    font-size: 15px;
    box-shadow: 0 0.125rem 0.25rem #00000013;
    transition: all .3s ease; }
    .input-search__input:disabled {
      color: #6c757d;
      background-color: #e9ecef !important; }
    .input-search__input:hover {
      box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15); }
    .input-search__input:focus, .input-search__input:valid {
      transform-origin: center;
      box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15); }
    .input-search__input:focus ~ .input-search__label, .input-search__input:valid ~ .input-search__label {
      top: 12px;
      font-size: 9px;
      left: 10px; }
  .input-search__label {
    padding: 3px 5px;
    padding-bottom: 1px;
    text-transform: initial;
    font-size: 13px;
    margin: 0;
    font-weight: 400;
    color: #d6d6d6;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 10px;
    transition: all .15s ease; }
    .input-search__label:hover {
      cursor: text; }
  .input-search__icon {
    position: absolute;
    right: 2px;
    top: 50%;
    padding: 6px 10px 6px 8px;
    transform: translateY(-50%);
    color: #2d572c; }
    .input-search__icon .load {
      animation: linear .6s loadTyping infinite; }

@keyframes loadTyping {
  from {
    transform: rotate(0deg); }
  to {
    transform: rotate(360deg); } }
    .input-search__icon svg {
      width: 18px; }

.detail-wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: auto;
  gap: 8px 10px;
  padding: 0 0; }
  .detail-wrapper__slide {
    flex: 1 1 445px;
    z-index: 2;
    max-width: 1000px;
    background-color: #000;
    height: calc(100vh - 102px);
    align-self: flex-start;
    border-radius: 3px; }
    @media (max-width: 600px) {
      .detail-wrapper__slide {
        height: 280px; } }
    @media (max-width: 426px) {
      .detail-wrapper__slide {
        position: sticky;
        top: 10px;
        margin-bottom: 8px; } }
    .detail-wrapper__slide__carousel {
      margin: 0 auto;
      width: 100%;
      height: inherit; }
      .detail-wrapper__slide__carousel .carousel-inner,
      .detail-wrapper__slide__carousel .carousel-item {
        height: inherit; }
  .detail-wrapper__cards-wrapper {
    align-self: flex-start;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    flex: 1 1;
    gap: 8px; }
    .detail-wrapper__cards-wrapper__card {
      flex: 1 1;
      border: solid 1px #d6d6d6;
      padding: 13px 13px;
      border-radius: 3px;
      min-width: 300px;
      height: auto; }
      .detail-wrapper__cards-wrapper__card__price {
        display: flex;
        align-items: center;
        justify-content: space-between; }
        .detail-wrapper__cards-wrapper__card__price > span {
          color: #2d572c;
          font-weight: 700;
          font-size: 20px;
          line-height: 0px; }
        .detail-wrapper__cards-wrapper__card__price .icon {
          font-size: 22px;
          color: #2d572c;
          cursor: pointer;
          transform-style: preserve-3d; }
          .detail-wrapper__cards-wrapper__card__price .icon.--favorite {
            color: #ff0000ec; }
      .detail-wrapper__cards-wrapper__card__middle {
        text-align: left;
        color: #6b8482;
        font-size: 14px;
        margin-top: 14px; }
        .detail-wrapper__cards-wrapper__card__middle p {
          line-height: 22px;
          font-weight: 400; }
          .detail-wrapper__cards-wrapper__card__middle p.make-model, .detail-wrapper__cards-wrapper__card__middle p.location {
            color: #394948; }
          .detail-wrapper__cards-wrapper__card__middle p.location {
            font-size: 13px;
            font-family: system-ui; }
    .detail-wrapper__cards-wrapper__contact-links {
      gap: 8px 20px;
      margin: 6px 0px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative; }
      .detail-wrapper__cards-wrapper__contact-links:before {
        content: "";
        width: 100%;
        position: absolute;
        margin: auto 0;
        height: 1px;
        background-color: #d6d6d6;
        z-index: 0; }
      .detail-wrapper__cards-wrapper__contact-links .btn-social {
        height: 40px;
        width: 40px;
        box-shadow: 0px 0px 0px 5px #fff;
        z-index: 1;
        text-align: center;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: 10em;
        cursor: pointer;
        background-color: #fff;
        transition: background-color .2s ease-in-out; }
        .detail-wrapper__cards-wrapper__contact-links .btn-social.--wapp {
          border: solid 1px #25D366;
          color: #25D366; }
          .detail-wrapper__cards-wrapper__contact-links .btn-social.--wapp:hover {
            background-color: #25D366;
            color: #fff; }
        .detail-wrapper__cards-wrapper__contact-links .btn-social.--share {
          border: solid 1px #ffae00;
          color: #ffae00; }
          .detail-wrapper__cards-wrapper__contact-links .btn-social.--share:hover {
            background-color: #ffae00;
            color: #fff; }
        .detail-wrapper__cards-wrapper__contact-links .btn-social.--email {
          border: solid 1px #2A76CE;
          color: #2A76CE; }
          .detail-wrapper__cards-wrapper__contact-links .btn-social.--email:hover {
            background-color: #2A76CE;
            color: #fff; }
        .detail-wrapper__cards-wrapper__contact-links .btn-social.--edit {
          border: solid 1px #646464;
          color: #7D797A; }
          .detail-wrapper__cards-wrapper__contact-links .btn-social.--edit:hover {
            background-color: #7D797A;
            color: #fff; }
        .detail-wrapper__cards-wrapper__contact-links .btn-social.--delete {
          border: solid 1px #b10b0b;
          color: #e12050; }
          .detail-wrapper__cards-wrapper__contact-links .btn-social.--delete:hover {
            background-color: #e12050;
            color: #fff; }

.skeleton-detail-page {
  flex: 1 1 445px;
  align-self: flex-start; }
  .skeleton-detail-page span {
    height: calc(100vh - 102px);
    width: 100%; }
    @media (max-width: 600px) {
      .skeleton-detail-page span {
        height: 280px; } }
  .skeleton-detail-page__info {
    flex: 1 1;
    align-self: flex-start;
    min-width: 300px; }
    .skeleton-detail-page__info span {
      height: calc((100vh - 125px) / 3);
      margin-bottom: 5px; }

.div-cards-related-component {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start; }
  .div-cards-related-component[background="price"] > .div-cards-related-component__title {
    background: #106d66;
    border: dashed 5px #08504a;
    box-shadow: 0 0.7rem 1.2rem #106d66c2 !important; }
  .div-cards-related-component[background="year"] > .div-cards-related-component__title {
    background: #ec9d13;
    border: dashed 5px #bd7901;
    box-shadow: 0 0.7rem 1.2rem #ec9d13c2 !important; }
  .div-cards-related-component__title {
    color: #ffffff;
    font-size: 14px;
    font-weight: 400;
    min-width: 200px;
    width: 100%;
    flex: 1 1 200px;
    background: #2A76CE;
    height: 250px;
    border-radius: 5px;
    border: dashed 5px #155299;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px 15px;
    box-shadow: 0 0.7rem 1.2rem #2a76cec2 !important; }
    @media (max-width: 600px) {
      .div-cards-related-component__title {
        height: 100px; } }
    .div-cards-related-component__title[right=true] {
      order: 2; }
      @media (max-width: 600px) {
        .div-cards-related-component__title[right=true] {
          order: 0; } }
  .div-cards-related-component__cards {
    display: flex;
    gap: 13px;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: flex-start;
    scroll-snap-type: x mandatory;
    padding: 10px 10px 15px 10px;
    overflow-x: auto;
    flex: 7 1 285px; }
    .div-cards-related-component__cards__item {
      scroll-snap-align: center; }
  .div-cards-related-component__concesss {
    color: #497839;
    font-size: 14px;
    font-weight: bold;
    min-width: 150px;
    flex: 1 1 200px;
    background: #c2c2c2;
    height: 250px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px 15px;
    box-shadow: 0 0.7rem 1.2rem #9b9b9b !important; }
    @media (max-width: 600px) {
      .div-cards-related-component__concesss {
        height: 100px; } }
    .div-cards-related-component__concesss[right=true] {
      order: 2; }
      @media (max-width: 600px) {
        .div-cards-related-component__concesss[right=true] {
          order: 0; } }
  .div-cards-related-component__card_concess {
    background-color: #656565; }

.gap {
  gap: 8px; }

.wrap-info_home .banner {
  height: 350px;
  width: 100%;
  position: absolute;
  transform-style: inherit;
  background-size: cover;
  z-index: -1;
  background-position: center;
  background-repeat: no-repeat; }
  .wrap-info_home .banner::after {
    content: '';
    width: 100%;
    background: white;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.407789) 30%, rgba(255, 255, 255, 0.75) 51%, rgba(255, 255, 255, 0.9) 69%, rgba(255, 255, 255, 0.96) 80%, white 97%);
    position: absolute;
    bottom: -1px;
    z-index: 0;
    left: 0;
    height: 60px; }

.wrap-info_home .body {
  position: relative;
  padding-top: 250px;
  padding-inline: 40px; }
  @media (max-width: 426px) {
    .wrap-info_home .body {
      padding-inline: 20px; } }
  .wrap-info_home .body ._info {
    flex-direction: column;
    align-items: flex-start;
    position: relative; }
    .wrap-info_home .body ._info .logo-store {
      width: 130px;
      height: 130px;
      overflow: hidden;
      padding: 5px;
      z-index: 1;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center; }
      .wrap-info_home .body ._info .logo-store img {
        width: 100%;
        object-fit: cover; }
    .wrap-info_home .body ._info .letter {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #000;
      border-radius: 50%;
      font-size: 30px;
      color: #fff;
      font-weight: 700; }
    .wrap-info_home .body ._info ._text {
      text-align: left; }
      .wrap-info_home .body ._info ._text h2 {
        font-weight: 700; }
      .wrap-info_home .body ._info ._text p {
        font-weight: 400;
        color: #6b8482;
        font-size: 14px;
        line-height: 10px; }
        @media (max-width: 426px) {
          .wrap-info_home .body ._info ._text p {
            line-height: 20px; } }

* {
  text-rendering: optimizeLegibility; }
  *::-webkit-scrollbar {
    width: 6px !important;
    height: 6px !important; }
  *::-webkit-scrollbar-thumb {
    background-color: #494a4c; }
  *::-webkit-scrollbar-track {
    background: #00000026; }

body {
  margin: 0;
  font-family: 'Poppins', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-display: optional;
  font-weight: 400;
  font-size: 13px;
  scroll-behavior: smooth; }

.fw-100 {
  font-weight: 100; }

.fw-200 {
  font-weight: 200; }

.fw-300 {
  font-weight: 300; }

.fw-400 {
  font-weight: 400; }

.fw-500 {
  font-weight: 500; }

.fw-600 {
  font-weight: 600; }

.fw-700 {
  font-weight: 700; }

.fw-800 {
  font-weight: 800; }

.fw-900 {
  font-weight: 900; }

.poiret {
  font-family: 'Poppins', sans-serif; }

.cursor-pointer {
  cursor: pointer; }

.shadow-c {
  box-shadow: 0 2.3vw 4.2vw -0.7vw rgba(0, 0, 0, 0.33); }

.montserrat {
  font-family: 'Montserrat', sans-serif; }

blockquote {
  margin: 0 0 0 0;
  border-radius: 3px;
  border-left: solid 5px #6b8482;
  background-color: #f1f1f1;
  padding: 8px 6px 8px 10px;
  font-size: 13px;
  font-weight: 400;
  color: #3c4c4a; }

.btc-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-color: #343a40;
  color: #fff;
  margin-bottom: 20px;
  transition: all .32s ease-in-out;
  scroll-snap-type: x mandatory;
  overflow-x: auto;
  z-index: 10; }
  .btc-wrapper__title {
    background-color: #f7931a;
    height: 45px;
    padding: 10px 10px;
    min-width: 150px;
    line-height: 28px;
    font-weight: 600;
    scroll-snap-align: start; }
  .btc-wrapper__values {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    height: 45px;
    padding: 0px 0px;
    flex: 1 1;
    gap: 0px 15px;
    scroll-snap-align: start; }
    .btc-wrapper__values__in {
      min-width: 150px;
      font-weight: 300;
      width: 100%;
      margin: 0 15px;
      position: relative; }
      .btc-wrapper__values__in:not(:last-child):after {
        content: '|';
        color: #fff;
        font-size: 20px;
        font-weight: 300;
        position: absolute;
        top: -5px;
        bottom: 0;
        right: calc(-130px/5); }
      .btc-wrapper__values__in img {
        background-color: #fff;
        padding: 2px;
        border-radius: 2px;
        width: 25px;
        margin-right: 5px; }
      .btc-wrapper__values__in span {
        position: relative;
        top: 2px;
        font-size: 14px;
        font-weight: 400; }

.publicationshome-wrapper {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 10px; }
  .publicationshome-wrapper__left {
    flex: 1 1; }
  .publicationshome-wrapper__right {
    position: sticky;
    top: 5px; }
    .publicationshome-wrapper__right__wapp-btn {
      background-color: #25D366;
      color: #fff;
      font-weight: 500;
      border: none;
      padding: 10px 10px;
      width: 100%;
      font-size: 15px;
      border-radius: 5px;
      margin-bottom: 10px;
      outline: none;
      vertical-align: middle;
      text-align: center;
      transition: all .2s ease-in-out;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 0.3rem 0.8rem #25d36678; }
      .publicationshome-wrapper__right__wapp-btn:hover {
        background-color: #128C7E;
        box-shadow: 0 0.3rem 0.8rem #128C7E78; }
      .publicationshome-wrapper__right__wapp-btn:active {
        background-color: #075E54;
        box-shadow: 0 0.3rem 0.8rem #075E5478; }
      .publicationshome-wrapper__right__wapp-btn span {
        position: relative;
        top: 2px; }
    .publicationshome-wrapper__right__ad {
      min-width: 180px;
      width: 100%;
      max-width: 220px;
      padding: 10px 8px 10px 8px;
      background-color: #128C7E;
      border-radius: 5px;
      overflow-y: auto;
      height: 90vh; }
      .publicationshome-wrapper__right__ad .ads-cards {
        border-radius: 5px;
        max-height: calc(70vh - 155px);
        overflow-y: auto; }
        .publicationshome-wrapper__right__ad .ads-cards__card-ad {
          border-radius: 5px;
          border: solid 1px #fff;
          overflow: hidden; }
          .publicationshome-wrapper__right__ad .ads-cards__card-ad:not(:last-child) {
            margin-bottom: 8px; }
          .publicationshome-wrapper__right__ad .ads-cards__card-ad img {
            width: 100%;
            height: 155px;
            object-fit: cover; }
          .publicationshome-wrapper__right__ad .ads-cards__card-ad .card-ad__footer a,
          .publicationshome-wrapper__right__ad .ads-cards__card-ad .card-ad__footer button {
            background-color: #075E54;
            cursor: pointer;
            color: #fff; }

.ads-cards[horizontal="horizontal"] {
  display: flex;
  align-items: flex-end;
  gap: 5px;
  justify-content: center; }
  .ads-cards[horizontal="horizontal"] .ads-cards__card-ad {
    width: auto;
    border-radius: 5px; }
    .ads-cards[horizontal="horizontal"] .ads-cards__card-ad img {
      width: 100%;
      object-fit: contain;
      height: 230px;
      background-color: #000;
      border: double 10px #f5e432; }
    .ads-cards[horizontal="horizontal"] .ads-cards__card-ad .card-ad__footer {
      background-color: #000; }
      .ads-cards[horizontal="horizontal"] .ads-cards__card-ad .card-ad__footer a {
        color: #fff; }

.skeleton-home {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 5px;
  align-items: center;
  justify-content: center; }
  .skeleton-home span {
    min-width: 250px;
    max-width: 350px;
    flex: 1 1; }

.filter-search-order {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
  gap: 8px;
  position: sticky;
  top: 10px;
  flex-wrap: wrap;
  z-index: 5; }
  .filter-search-order .input-search {
    flex: 1 1; }
  .filter-search-order__buttons {
    gap: 5px; }
    .filter-search-order__buttons .icon_btn {
      display: flex;
      transition: all .2s ease;
      cursor: pointer;
      align-items: center;
      border: none;
      transform: scale(1);
      justify-content: center;
      background-color: #fff;
      color: #000;
      box-shadow: 0 0.125rem 0.25rem #00000025;
      height: 40px;
      font-size: 15px;
      width: 40px;
      border-radius: 5px; }
      .filter-search-order__buttons .icon_btn:hover {
        background-color: #343a40;
        color: #fff;
        transform: scale(0.9); }

.principalCarouselAndAd {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  height: calc(100vh / 2.1);
  gap: 8px 8px;
  z-index: 1; }
  @media (max-width: 600px) {
    .principalCarouselAndAd {
      height: 280px; } }
  .principalCarouselAndAd__slide {
    flex: 1 1;
    z-index: 2;
    background-color: #000;
    height: calc(100vh / 2.1);
    align-self: flex-start;
    border-radius: 3px; }
    @media (max-width: 600px) {
      .principalCarouselAndAd__slide {
        height: 280px; } }
    @media (max-width: 426px) {
      .principalCarouselAndAd__slide {
        margin-bottom: 8px; } }
    .principalCarouselAndAd__slide__carousel {
      margin: 0 auto;
      width: 100%;
      height: inherit; }
      .principalCarouselAndAd__slide__carousel .carousel-inner,
      .principalCarouselAndAd__slide__carousel .carousel-item {
        height: inherit; }
  .principalCarouselAndAd__ad {
    width: 300px;
    height: inherit;
    max-width: 512px;
    background-color: #000;
    border: double 8px #f5e432; }
    @media (max-width: 768px) {
      .principalCarouselAndAd__ad {
        display: none; } }
    @media screen and (min-width: 1445px) {
      .principalCarouselAndAd__ad {
        min-width: calc(100vw / 5); } }
    .principalCarouselAndAd__ad img {
      object-fit: cover;
      width: 100%;
      height: 100%; }

.footerPage {
  background-color: #e8e8e8;
  padding: 1em;
  margin-top: 4em;
  position: relative;
  padding-top: 100px; }
  .footerPage .custom-shape-divider-top-1656462391 {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    overflow: hidden;
    line-height: 0; }
    .footerPage .custom-shape-divider-top-1656462391 .shape-fill {
      fill: #FFFFFF; }
    .footerPage .custom-shape-divider-top-1656462391 svg {
      position: relative;
      display: block;
      width: calc(100% + 1.3px);
      height: 90px; }
  .footerPage__ul li {
    margin-bottom: 8px; }

.footer__line-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #2d572c;
  width: 100%;
  padding: 8px 8px;
  font-size: 11px;
  font-weight: 300;
  color: #fff;
  flex-wrap: wrap;
  gap: 0px 12px; }
  @media (max-width: 426px) {
    .footer__line-bottom {
      justify-content: center; } }
  .footer__line-bottom > span {
    min-width: -moz-fit-content;
    min-width: fit-content;
    font-weight: 500; }
  .footer__line-bottom__links {
    position: relative;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    grid-gap: 0px 12px;
    gap: 0px 12px;
    flex-direction: column; }
    .footer__line-bottom__links:after {
      content: '';
      background: #ababab;
      position: absolute;
      top: 50%;
      width: 1px;
      height: 100%;
      transform: translateY(-50%);
      left: -10px; }
    .footer__line-bottom__links a {
      position: relative;
      min-width: -moz-fit-content;
      min-width: fit-content;
      line-height: 18px; }
    .footer__line-bottom__links span {
      color: #7d7d7d;
      text-decoration: underline; }

.carousel-principal-text {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 45px;
  line-height: 30px;
  -webkit-backdrop-filter: blur(8px);
          backdrop-filter: blur(8px);
  z-index: 1;
  width: 100%;
  height: auto;
  padding: 8px 2px; }
  .carousel-principal-text p {
    color: #000;
    font-size: 20px;
    font-weight: 500; }
    @media (max-width: 426px) {
      .carousel-principal-text p:not(.--principal) {
        display: none; } }
    .carousel-principal-text p.--principal {
      font-size: clamp(1rem, 5vw, 2.3rem);
      color: #2d572c;
      font-weight: 900;
      text-shadow: 0px 1px 0px #fff,  0px -1px 0px #fff,  -1px 0px 0px #fff,  1px 0px 0px #fff; }
`, "",{"version":3,"sources":["webpack://./src/styles/components/_card.scss","webpack://./src/styles/vars.scss","webpack://./src/styles/components/_inputSearch.scss","webpack://./src/styles/detail_page.scss","webpack://./src/styles/components/_divCard.scss","webpack://./src/styles/components/_concessionaire.scss","webpack://./src/styles/style.scss"],"names":[],"mappings":"AAAA;EAEI,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;EACT,eAAe,EAAA;EC+Bf;IDrCJ;MASQ,uBAAuB,EAAA,EAE9B;;AACD;EAEI,qBAAqB,EAAA;;AAEzB;EAOI,kBAAkB;EAClB,eAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,2DAA0D;EAC1D,yBAAyB;EACzB,4BAA4B;EAC5B,wDAAuD,EAAA;ECAvD;IDrBJ;MAIQ,aAAa;MACb,UAAU,EAAA,EAuJjB;EA5JD;IAwBQ,wDAAmD;IACnD,YAAY;IACZ,wBAAwB;IACxB,UAAU,EAAA;EA3BlB;IA+BQ,UAAU;IACV,mCAAmC,EAAA;EAhC3C;IAoCQ,SAAS;IACT,UAAU,EAAA;EArClB;IA2CY,UAAU;IACV,oBAAoB,EAAA;EAI5B;IAEI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,yBAAyB;IACzB,cAAc;IACd,WAAW;IACX,mCAAmC;IACnC,kBAAkB;IAClB,4BAA4B;IAC5B,UAAU,EAAA;IAhBb;MAoBO,yBAAyB,EAAA;MApBhC;QAuBW,sBAAsB,EAAA;IAG9B;MAEI,eAAe;MACf,kBAAkB;MAClB,QAAQ;MACR,cAAc;MACd,sCAAsC,EAAA;;AAE1C;EAEI;IAEI,uBAAuB,EAAA;EAE3B;IAEI,yBAAyB,EAAA,EAAA;EAIrC;IAEI,4BAA4B,EAAA;IAC5B;MAEI,cCnHK;MDoHL,eAAe;MACf,gBAAgB,EAAA;IAEpB;MAEI,WAAW;MACX,eAAe,EAAA;EAGvB;IAEI,uBAAuB,EAAA;IACvB;MAEI,kBAAkB;MAClB,2BAA2B;MAQ3B,WAAW;MACX,aAAa,EAAA;MAZhB;QAMO,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,kCAA0B;gBAA1B,0BAA0B,EAAA;MATjC;QAeO,4BAA4B;QAC5B,kBAAkB;QAClB,UAAU;QACV,sBAAsB;QACtB,UAAU;QACV,uBAAuB;QACvB,YAAY,EAAA;EAKxB;IAEI,4BAA4B;IAC5B,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,OAAO;IACP,QAAQ;IACR,cAAc;IACd,4BAA4B;IAC5B,sBAAsB;IACtB,UAAU,EAAA;EAGd;IAEI,oCAAoC,EAAA;;AAI5C;EAEI;IAEI,UAAU;IACV,qBAAqB,EAAA;EAEzB;IAEI,UAAU;IACV,mBAAmB,EAAA,EAAA;;AExL3B;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,kBAAkB,EAAA;EAElB;IAEE,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,wCAAwC;IACxC,wBAAwB,EAAA;IAdzB;MAiBG,cAAc;MACd,oCAAoC,EAAA;IAlBvC;MAuBG,6CAAwC,EAAA;IAvB3C;MA6BG,wBAAwB;MACxB,6CAAwC,EAAA;IA9B3C;MAkCG,SAAS;MACT,cAAc;MACd,UAAU,EAAA;EAId;IAEE,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,cDhDgB;ICiDhB,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,UAAU;IACV,yBAAyB,EAAA;IAb1B;MAgBG,YAAY,EAAA;EAIhB;IAEE,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,yBAAyB;IACzB,2BAA2B;IAC3B,cD3Ea,EAAA;ICoEd;MAUG,yCAAyC,EAAA;;AAE3C;EAEE;IACE,uBAAuB,EAAA;EACvB;IACA,yBAAyB,EAAA,EAAA;IAjB9B;MAsBG,WAAW,EAAA;;AC1FjB;EAEE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,YAAY,EAAA;EAEZ;IAEE,eAAa;IACb,UAAU;IACV,iBAAiB;IACjB,sBAAsB;IACtB,2BAA2B;IAC3B,sBAAsB;IACtB,kBAAkB,EAAA;IF0ClB;MElDF;QAWI,aAAa,EAAA,EAqBhB;IFUC;ME1CF;QAeI,gBAAgB;QAChB,SAAS;QACT,kBAAkB,EAAA,EAerB;IAZC;MAEE,cAAc;MACd,WAAW;MACX,eAAe,EAAA;MAJhB;;QASG,eAAe,EAAA;EAIrB;IAEE,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,SAAS;IACT,QAAQ,EAAA;IAER;MAEE,SAAO;MACP,yBFhDc;MEiDd,kBAAkB;MAClB,kBAAkB;MAClB,gBAAgB;MAChB,YAAY,EAAA;MAEZ;QAEE,aAAa;QACb,mBAAmB;QACnB,8BAA8B,EAAA;QAJ/B;UAOG,cFrEO;UEsEP,gBAAgB;UAChB,eAAe;UACf,gBAAgB,EAAA;QAVnB;UAcG,eAAe;UACf,cF7EO;UE8EP,eAAe;UACf,4BAA4B,EAAA;UAjB/B;YAoBK,gBFzEM,EAAA;ME6EZ;QAEE,gBAAgB;QAChB,cAAc;QACd,eAAe;QACf,gBAAgB,EAAA;QALjB;UAQG,iBAAiB;UACjB,gBAAgB,EAAA;UATnB;YAaK,cAAc,EAAA;UAbnB;YAiBK,eAAe;YACf,sBAAsB,EAAA;IAK9B;MAEE,aAAa;MACb,eAAe;MACf,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,kBAAkB,EAAA;MAPnB;QAUG,WAAW;QACX,WAAW;QACX,kBAAkB;QAClB,cAAc;QACd,WAAW;QACX,yBFpHY;QEqHZ,UAAU,EAAA;MAhBb;QAqBG,YAAY;QACZ,WAAW;QACX,gCAAgC;QAChC,UAAU;QACV,kBAAkB;QAClB,oBAAoB;QACpB,mBAAmB;QACnB,uBAAuB;QACvB,mBAAmB;QACnB,eAAe;QACf,sBAAsB;QACtB,4CAA4C,EAAA;QAhC/C;UAoCK,yBFvII;UEwIJ,cFxII,EAAA;UEmGT;YAwCO,yBF3IE;YE4IF,WAAW,EAAA;QAzClB;UA8CK,yBAAyB;UACzB,cAAc,EAAA;UA/CnB;YAkDO,yBAAyB;YACzB,WAAW,EAAA;QAnDlB;UAwDK,yBFlKI;UEmKJ,cFnKI,EAAA;UE0GT;YA4DO,yBFtKE;YEuKF,WAAW,EAAA;QA7DlB;UAkEK,yBAAyB;UACzB,cAAc,EAAA;UAnEnB;YAsEO,yBAAyB;YACzB,WAAW,EAAA;QAvElB;UA4EK,yBAAyB;UACzB,cAAc,EAAA;UA7EnB;YAgFO,yBAAyB;YACzB,WAAW,EAAA;;AAOvB;EAEE,eAAa;EACb,sBAAsB,EAAA;EAHxB;IAMI,2BAA2B;IAC3B,WAAW,EAAA;IF/IX;MEwIJ;QAUM,aAAa,EAAA,EAEhB;EACD;IAEE,SAAS;IACT,sBAAsB;IACtB,gBAAgB,EAAA;IAJjB;MAOG,iCAAiC;MACjC,kBAAkB,EAAA;;AC1NxB;EAEE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,2BAA2B,EAAA;EAN7B;IASI,mBAAmB;IACnB,0BAA0B;IAC1B,gDAAgD,EAAA;EAXpD;IAeI,mBAAmB;IACnB,0BAA0B;IAC1B,gDAAgD,EAAA;EAElD;IAEE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,mBHxBU;IGyBV,aAAa;IACb,kBAAkB;IAClB,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,gDAAgD,EAAA;IH0BhD;MG1CF;QAmBI,aAAa,EAAA,EAUhB;IA7BA;MAuBG,QAAQ,EAAA;MHmBV;QG1CD;UA0BK,QAAQ,EAAA,EAEX;EAGH;IAEE,aAAa;IACb,SAAS;IACT,iBAAiB;IACjB,mBAAmB;IACnB,2BAA2B;IAC3B,6BAA6B;IAC7B,4BAA4B;IAC5B,gBAAgB;IAChB,eAAa,EAAA;IACb;MAEE,yBAAyB,EAAA;EAI7B;IAEE,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,8CAA8C,EAAA;IHnB9C;MGMF;QAgBI,aAAa,EAAA,EAUhB;IA1BA;MAoBG,QAAQ,EAAA;MH1BV;QGMD;UAuBK,QAAQ,EAAA,EAEX;EAGH;IAEE,yBAAyB,EAAA;;AC/F7B;EAEE,QAAQ,EAAA;;AAEV;EAeI,aArBiB;EAsBjB,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,sBAAsB;EACtB,WAAW;EACX,2BAA2B;EAC3B,4BAA4B,EAAA;EAtBhC;IA0BM,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,wMACoK;IACpK,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,OAAO;IACP,YAAY,EAAA;;AAnClB;EAyCI,kBAAkB;EAClB,kBAAiC;EACjC,oBAAoB,EAAA;EJIpB;II/CJ;MA+CM,oBAAoB,EAAA,EA+DvB;EA9GH;IAoDM,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB,EAAA;IAtDxB;MA0DQ,YAAY;MACZ,aAAa;MACb,gBAAgB;MAChB,YAAY;MACZ,UAAU;MACV,gBAAgB;MAChB,aAAa;MACb,mBAAmB;MACnB,uBAAuB,EAAA;MAlE/B;QAsEU,WAAW;QACX,iBAAiB,EAAA;IAvE3B;MA6EQ,WAAW;MACX,YAAY;MACZ,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,gBAAgB;MAChB,kBAAkB;MAClB,eAAe;MACf,WAAW;MACX,gBAAgB,EAAA;IAtFxB;MA2FQ,gBAAgB,EAAA;MA3FxB;QA8FU,gBAAgB,EAAA;MA9F1B;QAkGU,gBAAgB;QAChB,cAAc;QACd,eAAe;QACf,iBAAiB,EAAA;QJtDvB;UI/CJ;YAyGY,iBAAiB,EAAA,EAEpB;;ACtGT;EAYE,kCAAkC,EAAA;EAZpC;IAGI,qBAAoB;IACpB,sBAAqB,EAAA;EAJzB;IAOI,yBAAyB,EAAA;EAP7B;IAUI,qBAAqB,EAAA;;AAIzB;EAEI,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,kCAAkC;EAClC,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,uBAAuB,EAAA;;AAGvB;EACI,gBLrBK,EAAA;;AKoBT;EACI,gBLrBU,EAAA;;AKoBd;EACI,gBLrBe,EAAA;;AKoBnB;EACI,gBLrBoB,EAAA;;AKoBxB;EACI,gBLrByB,EAAA;;AKoB7B;EACI,gBLrB8B,EAAA;;AKoBlC;EACI,gBLrBmC,EAAA;;AKoBvC;EACI,gBLrBwC,EAAA;;AKoB5C;EACI,gBLrB6C,EAAA;;AKyBrD;EAEE,kCAAkC,EAAA;;AAGpC;EAEE,eAAe,EAAA;;AAGjB;EAEE,oDAAmD,EAAA;;AAErD;EAEE,qCAAqC,EAAA;;AAGvC;EAEE,eAAe;EACf,kBAAkB;EAClB,8BAA8B;EAC9B,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc,EAAA;;AAGhB;EAEE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,yBL5EY;EK6EZ,WAAW;EACX,mBAAmB;EACnB,gCAAgC;EAChC,6BAA6B;EAC7B,gBAAgB;EAChB,WAAW,EAAA;EAEX;IAEE,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB,EAAA;EAE1B;IAEE,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,YAAY;IACZ,gBAAgB;IAChB,SAAO;IACP,aAAa;IACb,wBAAwB,EAAA;IACxB;MAEE,gBAAgB;MAChB,gBAAgB;MAChB,WAAW;MACX,cAAc;MACd,kBAAkB,EAAA;MANnB;QAUG,YAAY;QACZ,WAAW;QACX,eAAe;QACf,gBAAgB;QAChB,kBAAkB;QAClB,SAAS;QACT,SAAS;QACT,qBAAqB,EAAA;MAjBxB;QAqBG,sBAAsB;QACtB,YAAY;QACZ,kBAAkB;QAClB,WAAW;QACX,iBAAiB,EAAA;MAzBpB;QA6BG,kBAAkB;QAClB,QAAQ;QACR,eAAe;QACf,gBAAgB,EAAA;;AAMxB;EAEE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,SAAS,EAAA;EAET;IAEE,SAAO,EAAA;EAET;IAEE,gBAAgB;IAChB,QAAQ,EAAA;IAER;MAEE,yBLxJQ;MKyJR,WAAW;MACX,gBAAgB;MAChB,YAAY;MACZ,kBAAkB;MAClB,WAAW;MACX,eAAe;MACf,kBAAkB;MAClB,mBAAmB;MACnB,aAAa;MACb,sBAAsB;MACtB,kBAAkB;MAClB,+BAA+B;MAC/B,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,qCAAqC,EAAA;MAlBtC;QAqBG,yBAAyB;QACzB,qCAAqC,EAAA;MAtBxC;QA0BG,yBAAyB;QACzB,qCAAqC,EAAA;MA3BxC;QAgCG,kBAAkB;QAClB,QAAQ,EAAA;IAGZ;MAEE,gBAAgB;MAChB,WAAW;MACX,gBAAgB;MAChB,0BAA0B;MAC1B,yBAAyB;MACzB,kBAAkB;MAClB,gBAAgB;MAChB,YAAY,EAAA;MATb;QAaG,kBAAkB;QAClB,8BAA8B;QAC9B,gBAAgB,EAAA;QAfnB;UAkBK,kBAAkB;UAClB,sBAAsB;UACtB,gBAAgB,EAAA;UApBrB;YAwBO,kBAAkB,EAAA;UAxBzB;YA4BO,WAAW;YACX,aAAa;YACb,iBAAiB,EAAA;UA9BxB;;YAsCS,yBAAyB;YACzB,eAAe;YACf,WAAW,EAAA;;AAQzB;EAEE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,uBAAuB,EAAA;EALzB;IASI,WAAW;IACX,kBAAkB,EAAA;IAVtB;MAaM,WAAW;MACX,mBAAmB;MACnB,aAAa;MACb,sBAAsB;MACtB,2BAA2B,EAAA;IAjBjC;MAqBM,sBAAsB,EAAA;MArB5B;QAwBQ,WAAW,EAAA;;AAKnB;EAEE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB,EAAA;EANzB;IAUI,gBAAgB;IAChB,gBAAgB;IAChB,SAAO,EAAA;;AAIX;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,UAAU,EAAA;EAVZ;IAcI,SAAO,EAAA;EAET;IAEE,QAAQ,EAAA;IAFT;MAMG,aAAa;MACb,wBAAwB;MACxB,eAAe;MACf,mBAAmB;MACnB,YAAY;MACZ,mBAAmB;MACnB,uBAAuB;MACvB,sBAAsB;MACtB,WAAW;MACX,wCAAwC;MACxC,YAAY;MACZ,eAAe;MACf,WAAW;MACX,kBAAkB,EAAA;MAnBrB;QAsBK,yBLrUM;QKsUN,WAAW;QACX,qBAAoB,EAAA;;AAK5B;EAEE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,uBAAuB;EACvB,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,UAAU,EAAA;EL1RR;IKiRJ;MAYI,aAAa,EAAA,EAwDhB;EArDC;IAEE,SAAS;IACT,UAAU;IACV,sBAAsB;IACtB,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB,EAAA;ILvSlB;MKgSF;QAUI,aAAa,EAAA,EAmBhB;ILrUC;MKwSF;QAcI,kBAAkB,EAAA,EAerB;IAZC;MAEE,cAAc;MACd,WAAW;MACX,eAAe,EAAA;MAJhB;;QASG,eAAe,EAAA;EAIrB;IAUE,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,0BAA0B,EAAA;ILpX1B;MKsWF;QAII,aAAa,EAAA,EAkBhB;IAhBC;MANF;QAQI,0BAA0B,EAAA,EAc7B;IAtBA;MAkBG,iBAAiB;MACjB,WAAW;MACX,YAAY,EAAA;;AAIlB;EAEE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,kBAAkB,EAAA;EANpB;IAUI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,gBAAgB;IAChB,cAAc,EAAA;IAflB;MAmBM,aAAa,EAAA;IAnBnB;MAuBM,kBAAkB;MAClB,cAAc;MACd,yBAAyB;MACzB,YAAY,EAAA;EAGf;IAIG,kBAAkB,EAAA;;AAIxB;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,aAAa,EAAA;EL/YX;IKmYJ;MAgBI,uBAAuB,EAAA,EAwC1B;EAxDD;IAqBI,2BAAsB;IAAtB,sBAAsB;IACtB,gBAAgB,EAAA;EAElB;IAEE,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,sBAAsB,EAAA;IARvB;MAWG,WAAW;MACX,mBAAmB;MACnB,kBAAkB;MAClB,QAAQ;MACR,UAAU;MACV,YAAY;MACZ,2BAA2B;MAC3B,WAAW,EAAA;IAlBd;MAsBG,kBAAkB;MAClB,2BAAsB;MAAtB,sBAAsB;MACtB,iBAAiB,EAAA;IAxBpB;MA4BG,cAAc;MACd,0BAA0B,EAAA;;AAKhC;EAEE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,kCAA0B;UAA1B,0BAA0B;EAC1B,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gBAAgB,EAAA;EAXlB;IAcI,WAAW;IACX,eAAe;IACf,gBAAgB,EAAA;IL7chB;MK6bJ;QAsBQ,aAAa,EAAA,EAEhB;IAxBL;MA4BM,mCAAmC;MACnC,cL/gBW;MKghBX,gBAAgB;MAChB,wFAG8B,EAAA","sourcesContent":[".wrapper-card-publications\n{\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n    gap: 12px;\n    flex-wrap: wrap;\n    @include mobile-sm()\n    {\n        justify-content: center;\n    }\n}\na.card-anchor_item\n{\n    text-decoration: none;\n}\n.custom-card-component\n{\n    @include mobile-sm()\n    {\n        flex: initial;\n        width: 95%;\n    }\n    position: relative;\n    flex: 1 250px;\n    overflow: hidden;\n    min-width: 250px;\n    max-width: 350px;\n    background-color: #fff;\n    height: 250px;\n    max-height: 250px;\n    border-radius: 5px;\n    cursor: pointer;\n    transform: scale(1);\n    animation: scale-in .5s cubic-bezier(0.07, -0.01, 0, 1.19);\n    animation-fill-mode: both;\n    transform-style: preserve-3d;\n    transition: all .2s cubic-bezier(0.075, 0.82, 0.165, 1);\n    &:hover\n    {\n        box-shadow: 0 .5rem 1rem rgba(0,0,0,.15) !important;\n        height: auto;\n        transform-origin: center;\n        z-index: 1;\n    }\n    &:hover > &__edit-fav\n    {\n        left: 15px;\n        transform: scale(1.05) rotate(0deg);\n    }\n    &:hover > &__card-footer\n    {\n        bottom: 0;\n        opacity: 1;\n    }\n    &:hover &__card-body\n    {\n        &__img > img\n        {\n            width: 95%;\n            object-position: top;\n        }\n    }\n\n    &__edit-fav\n    {\n        width: 40px;\n        height: 33px;\n        background-color: #cecece;\n        font-size: 10px;\n        vertical-align: middle;\n        border: none;\n        position: absolute;\n        top: 25%;\n        transform: rotate(180deg);\n        margin: auto 0;\n        left: -50px;\n        box-shadow: 0 0.5rem 1rem #00000057;\n        border-radius: 5px;\n        transition: all .2s ease-out;\n        z-index: 2;\n\n        &.isFav\n        {\n            background-color: #3ba338;\n            svg\n            {\n                color: #fff !important;\n            }\n        }\n        &__loader\n        {\n            font-size: 16px;\n            position: relative;\n            top: 1px;\n            color: #565252;\n            animation: loader 1.5s linear infinite;\n        }\n        @keyframes loader\n        {\n            0%\n            {\n                transform: rotate(0deg);\n            }\n            100%\n            {\n                transform: rotate(360deg);\n            }\n        }\n    }\n    &__card-header\n    {\n        padding: 10px 15px 10px 15px;\n        &__title\n        {\n            color: $primary;\n            font-size: 14px;\n            font-weight: 800;\n        }\n        &__price\n        {\n            color: #000;\n            font-size: 13px;\n        }\n    }\n    &__card-body\n    {\n        padding: 0px 0px 10px 0;\n        &__img\n        {\n            position: relative;\n            background-position: center;\n            .overlay-blur\n            {\n                width: 100%;\n                height: 100%;\n                position: absolute;\n                backdrop-filter: blur(3px);\n            }\n            width: 100%;\n            height: 200px;\n            img\n            {\n                transition: all .2s ease-out;\n                position: relative;\n                z-index: 1;\n                object-fit: scale-down;\n                width: 85%;\n                object-position: center;\n                height: 100%;\n            }\n        }\n    }\n\n    &__card-footer\n    {\n        padding: 10px 10px 10px 10px;\n        position: absolute;\n        z-index: 2;\n        bottom: -60px;\n        left: 0;\n        right: 0;\n        margin: 0 auto;\n        transition: all .2s ease-out;\n        background-color: #fff;\n        opacity: 0;\n    }\n\n    &__concess-footer\n    {\n        background-color: #656565 !important;\n    }\n}\n\n@keyframes scale-in\n{\n    0%\n    {\n        opacity: 0;\n        transform: scale(0.9);\n    }\n    100%\n    {\n        opacity: 1;\n        transform: scale(1);\n    }\n\n    \n}\n\n    ","$primary: #2d572c;\n$secondary: #191919;\n$dark: #343a40;\n$info: #2A76CE;\n$grey: #c8c4c4;\n$greyBorder:#646464;\n$text-color: #6b8482;\n$grey-dark: #888787;\n$grey-light: #d6d6d6;\n$danger: #ff0000ec;\n$wapp: #25D366;\n$pc-half: 1025px;\n$tablet: 768px;\n$mobile: 426px;\n$mobile-sm: 325px;\n$mobile-md: 375px;\n$mobile-half: 600px;\n$weights: 100, 200, 300, 400, 500, 600, 700, 800, 900;\n\n@mixin tablet \n{\n    @media (max-width: #{$tablet})\n    {\n        @content;\n    }    \n}\n\n@mixin mobile-md \n{\n    @media (max-width: #{$mobile-md})\n    {\n        @content;\n    }    \n}\n\n@mixin mobile-sm \n{\n    @media (max-width: #{$mobile-sm})\n    {\n        @content;\n    }    \n}\n\n@mixin pc-half\n{\n    @media (max-width: #{$pc-half})\n    {\n        @content;\n    }\n}\n\n@mixin mobile\n{\n    @media (max-width: #{$mobile})\n    {\n        @content;\n    }    \n}\n\n@mixin mobile-half\n{\n    @media (max-width: #{$mobile-half})\n    {\n        @content;\n    }    \n}",".input-search\n{\n  position: relative;\n  min-width: 230px;\n  width: 100%;\n  margin: 0 auto;\n  border-radius: 5px;\n  \n  &__input\n  {\n    width: 100%;\n    border: none;\n    padding: 15px 38px 3px 15px;\n    font-weight: 400;\n    background: #fff;\n    height: 40px;\n    color: #585858;\n    border-radius: 5px;\n    outline: none;\n    min-width: 200px;    \n    font-size: 15px;\n    box-shadow: 0 0.125rem 0.25rem #00000013;\n    transition: all .3s ease;\n\n    &:disabled {\n      color: #6c757d;\n      background-color: #e9ecef !important;\n    }\n\n    &:hover\n    {\n      box-shadow: 0 .5rem 1rem rgba(0,0,0,.15);\n    }\n    \n    &:focus,\n    &:valid\n    {\n      transform-origin: center;\n      box-shadow: 0 .5rem 1rem rgba(0,0,0,.15);\n    }\n    &:focus~.input-search__label, &:valid~.input-search__label\n    {\n      top: 12px;\n      font-size: 9px;\n      left: 10px;\n    }\n  }\n  \n  &__label\n  {\n    padding: 3px 5px;\n    padding-bottom: 1px;\n    text-transform: initial;\n    font-size: 13px;\n    margin: 0;\n    font-weight: 400;\n    color: $grey-light;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    left: 10px;\n    transition: all .15s ease;\n    &:hover\n    {\n      cursor: text;\n    }\n  }\n\n  &__icon\n  {\n    position: absolute;\n    right: 2px;\n    top: 50%;\n    padding: 6px 10px 6px 8px;\n    transform: translateY(-50%);\n    color: $primary;\n    .load\n    {\n      animation: linear .6s loadTyping infinite;\n    }\n    @keyframes loadTyping \n    {\n      from{\n        transform: rotate(0deg);\n      } to {\n        transform: rotate(360deg);\n      } \n    }\n    svg\n    {\n      width: 18px;\n    }\n  }\n}",".detail-wrapper\n{\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  height: auto;\n  gap: 8px 10px;\n  padding: 0 0;\n\n  &__slide\n  {\n    flex: 1 445px;\n    z-index: 2;\n    max-width: 1000px;\n    background-color: #000;\n    height: calc(100vh - 102px);\n    align-self: flex-start;\n    border-radius: 3px;\n    @include mobile-half()\n    {\n      height: 280px;\n    }\n    @include mobile\n    {\n      position: sticky;\n      top: 10px;\n      margin-bottom: 8px;\n    }\n\n    &__carousel\n    {\n      margin: 0 auto;\n      width: 100%;\n      height: inherit;\n\n      .carousel-inner,\n      .carousel-item\n      {\n        height: inherit;\n      }\n    }\n  }\n  &__cards-wrapper\n  {\n    align-self: flex-start;\n    display: flex;\n    justify-content: center;\n    flex-wrap: wrap;\n    flex: 1 1;\n    gap: 8px;\n\n    &__card\n    {\n      flex: 1;\n      border: solid 1px $grey-light;\n      padding: 13px 13px;\n      border-radius: 3px;\n      min-width: 300px;\n      height: auto;\n\n      &__price\n      {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        & > span\n        {\n          color: $primary;\n          font-weight: 700;\n          font-size: 20px;\n          line-height: 0px;\n        }\n        .icon\n        {\n          font-size: 22px;\n          color: $primary;\n          cursor: pointer;\n          transform-style: preserve-3d;\n          &.--favorite\n          {\n            color: $danger;\n          }\n        }\n      }\n      &__middle\n      {\n        text-align: left;\n        color: #6b8482;\n        font-size: 14px;\n        margin-top: 14px;\n        p\n        {\n          line-height: 22px;\n          font-weight: 400;\n          &.make-model,\n          &.location\n          {\n            color: #394948;\n          }\n          &.location\n          {\n            font-size: 13px;\n            font-family: system-ui;\n          }\n        }\n      }\n    }\n    &__contact-links\n    {\n      gap: 8px 20px;\n      margin: 6px 0px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      position: relative;\n      &:before\n      {\n        content: \"\";\n        width: 100%;\n        position: absolute;\n        margin: auto 0;\n        height: 1px;\n        background-color: $grey-light;\n        z-index: 0;\n      }\n\n      .btn-social \n      {\n        height: 40px;\n        width: 40px;\n        box-shadow: 0px 0px 0px 5px #fff;\n        z-index: 1;\n        text-align: center;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        border-radius: 10em;\n        cursor: pointer;\n        background-color: #fff;\n        transition: background-color .2s ease-in-out;\n\n        &.--wapp\n        {\n          border: solid 1px $wapp;\n          color: $wapp;\n          &:hover\n          {\n            background-color: $wapp;\n            color: #fff;\n          }\n        }\n        &.--share\n        {\n          border: solid 1px #ffae00;\n          color: #ffae00;\n          &:hover\n          {\n            background-color: #ffae00;\n            color: #fff;\n          }\n        }\n        &.--email\n        {\n          border: solid 1px $info;\n          color: $info;\n          &:hover\n          {\n            background-color: $info;\n            color: #fff;\n          }\n        }\n        &.--edit\n        {\n          border: solid 1px #646464;\n          color: #7D797A;\n          &:hover\n          {\n            background-color: #7D797A;\n            color: #fff;\n          }\n        }\n        &.--delete\n        {\n          border: solid 1px #b10b0b;\n          color: #e12050;\n          &:hover\n          {\n            background-color: #e12050;\n            color: #fff;\n          }\n        }\n      }\n    }\n  }\n}\n.skeleton-detail-page\n{\n  flex: 1 445px;\n  align-self: flex-start;\n  span\n  {\n    height: calc(100vh - 102px);\n    width: 100%;\n    @include mobile-half()\n    {\n      height: 280px;\n    }\n  }\n  &__info\n  {\n    flex: 1 1;\n    align-self: flex-start;\n    min-width: 300px;\n    span\n    {\n      height: calc((100vh - 125px) / 3);\n      margin-bottom: 5px;\n    }\n  }\n}",".div-cards-related-component\n{\n  display: flex;\n  gap: 15px;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-start;\n  &[background=\"price\"] > &__title\n  {\n    background: #106d66;\n    border: dashed 5px #08504a;\n    box-shadow: 0 0.7rem 1.2rem #106d66c2 !important;\n  }\n  &[background=\"year\"] > &__title\n  {\n    background: #ec9d13;\n    border: dashed 5px #bd7901;\n    box-shadow: 0 0.7rem 1.2rem #ec9d13c2 !important;\n  }\n  &__title\n  {\n    color: #ffffff;\n    font-size: 14px;\n    font-weight: 400;\n    min-width: 200px;\n    width: 100%;\n    flex: 1 1 200px;\n    background: $info;\n    height: 250px;\n    border-radius: 5px;\n    border: dashed 5px #155299;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 5px 15px;\n    box-shadow: 0 0.7rem 1.2rem #2a76cec2 !important;\n    @include mobile-half()\n    {\n      height: 100px;\n    }\n    &[right=true]\n    {\n      order: 2;\n      @include mobile-half()\n      {\n        order: 0;\n      }\n    }\n  }\n\n  &__cards\n  {\n    display: flex;\n    gap: 13px;\n    flex-wrap: nowrap;\n    align-items: center;\n    justify-content: flex-start;\n    scroll-snap-type: x mandatory;\n    padding: 10px 10px 15px 10px;\n    overflow-x: auto;\n    flex: 7 285px;\n    &__item\n    {\n      scroll-snap-align: center;\n    }\n  }\n\n  &__concesss\n  {\n    color: #497839;\n    font-size: 14px;\n    font-weight: bold;\n    min-width: 150px;\n    flex: 1 1 200px;\n    background: #c2c2c2;\n    height: 250px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 5px 15px;\n    box-shadow: 0 0.7rem 1.2rem #9b9b9b !important;\n    @include mobile-half()\n    {\n      height: 100px;\n    }\n    &[right=true]\n    {\n      order: 2;\n      @include mobile-half()\n      {\n        order: 0;\n      }\n    }\n  }\n  \n  &__card_concess \n  {\n    background-color: #656565;\n  }\n  \n}\n\n","$height-banner: 350px;\n\n.gap\n{\n  gap: 8px;\n}\n.wrap-info_home\n{\n  // margin-top: 53px;\n\n  .banner\n  {\n    // height: 180px;\n    // width: 100%;\n    // position: absolute;\n    // transform-style: inherit;  \n    // background-size: contain;\n    // z-index: -1;\n    // background-attachment: fixed;\n    // background-repeat: no-repeat;\n\n    height: $height-banner;\n    width: 100%;\n    position: absolute;\n    transform-style: inherit;\n    background-size: cover;\n    z-index: -1;\n    background-position: center;\n    background-repeat: no-repeat;\n\n    &::after\n    {\n      content: '';\n      width: 100%;\n      background: white;\n      background: linear-gradient(180deg,\n      rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.407789) 30%, rgba(255, 255, 255, 0.75) 51%, rgba(255, 255, 255, 0.9) 69%, rgba(255, 255, 255, 0.96) 80%, white 97%);\n      position: absolute;\n      bottom: -1px;\n      z-index: 0;\n      left: 0;\n      height: 60px;\n    }\n  }\n\n  .body\n  {\n    position: relative;\n    padding-top: $height-banner / 1.4;\n    padding-inline: 40px;\n\n    @include mobile()\n    {\n      padding-inline: 20px;\n    }\n\n    ._info\n    {\n      flex-direction: column;\n      align-items: flex-start;\n      position: relative;      \n\n      .logo-store\n      {\n        width: 130px;\n        height: 130px;\n        overflow: hidden;\n        padding: 5px;\n        z-index: 1;\n        background: #fff;\n        display: flex;\n        align-items: center;\n        justify-content: center;      \n        \n        img\n        {\n          width: 100%;\n          object-fit: cover;\n        }\n      }\n\n      .letter\n      {\n        width: 100%;\n        height: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background: #000;\n        border-radius: 50%;\n        font-size: 30px;\n        color: #fff;\n        font-weight: 700;\n      }\n\n      ._text\n      {\n        text-align: left;\n        h2\n        {\n          font-weight: 700;\n        }\n        p\n        {\n          font-weight: 400;\n          color: #6b8482;\n          font-size: 14px;\n          line-height: 10px;\n\n          @include mobile()\n          {\n            line-height: 20px;\n          }\n        }\n      }\n    }    \n  }\n}","// @import url('https://fonts.googleapis.com/css2?family=Josefin+Sans:wght@100;200;300;500;600;700&display=swap');\n@import \"fonts.css\";\n@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@100;200;300;500;600;700;900&display=swap');\n@import \"vars.scss\";\n@import \"animate.css\";\n@import \"components/card\";\n@import \"components/inputSearch\";\n@import \"detail_page\";\n@import \"components/divCard\";\n@import \"components/concessionaire\";\n\n*\n{\n  &::-webkit-scrollbar {\n    width: 6px!important;\n    height: 6px!important;\n  }    \n  &::-webkit-scrollbar-thumb {\n    background-color: #494a4c;\n  }    \n  &::-webkit-scrollbar-track {\n    background: #00000026;\n  }\n  text-rendering: optimizeLegibility;\n}\nbody\n{\n    margin: 0;\n    font-family: 'Poppins', sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-display: optional;\n    font-weight: 400;\n    font-size: 13px;\n    scroll-behavior: smooth;\n}\n@each $weight in $weights {\n    .fw-#{$weight} {\n        font-weight: $weight;\n    }\n}\n\n.poiret\n{\n  font-family: 'Poppins', sans-serif;\n}\n\n.cursor-pointer\n{\n  cursor: pointer;\n}\n\n.shadow-c\n{\n  box-shadow: 0 2.3vw 4.2vw -0.7vw rgba(0, 0, 0, .33);\n}\n.montserrat\n{\n  font-family: 'Montserrat', sans-serif;\n}\n\nblockquote\n{\n  margin: 0 0 0 0;\n  border-radius: 3px;\n  border-left: solid 5px #6b8482;\n  background-color: #f1f1f1;\n  padding: 8px 6px 8px 10px;\n  font-size: 13px;\n  font-weight: 400;\n  color: #3c4c4a;\n}\n\n.btc-wrapper\n{\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  background-color: $dark;\n  color: #fff;\n  margin-bottom: 20px;\n  transition: all .32s ease-in-out;\n  scroll-snap-type: x mandatory;\n  overflow-x: auto;\n  z-index: 10;\n\n  &__title\n  {\n    background-color: #f7931a;\n    height: 45px;\n    padding: 10px 10px;\n    min-width: 150px;\n    line-height: 28px;\n    font-weight: 600;\n    scroll-snap-align: start;\n  }\n  &__values\n  {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n    height: 45px;\n    padding: 0px 0px;\n    flex: 1;\n    gap: 0px 15px;\n    scroll-snap-align: start;\n    &__in\n    {\n      min-width: 150px;\n      font-weight: 300;\n      width: 100%;\n      margin: 0 15px;\n      position: relative;\n\n      &:not(:last-child):after\n      {\n        content: '|';\n        color: #fff;\n        font-size: 20px;\n        font-weight: 300;\n        position: absolute;\n        top: -5px;\n        bottom: 0;\n        right: calc(-130px/5);\n      }\n      img\n      {\n        background-color: #fff;\n        padding: 2px;\n        border-radius: 2px;\n        width: 25px;\n        margin-right: 5px;\n      }\n      span\n      {\n        position: relative;\n        top: 2px;\n        font-size: 14px;\n        font-weight: 400;\n      }\n    }\n  }\n}\n\n.publicationshome-wrapper\n{\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 10px;\n\n  &__left\n  {\n    flex: 1;\n  }\n  &__right\n  {\n    position: sticky;\n    top: 5px;\n\n    &__wapp-btn\n    {\n      background-color: $wapp;\n      color: #fff;\n      font-weight: 500;\n      border: none;\n      padding: 10px 10px;\n      width: 100%;\n      font-size: 15px;\n      border-radius: 5px;\n      margin-bottom: 10px;\n      outline: none;\n      vertical-align: middle;\n      text-align: center;\n      transition: all .2s ease-in-out;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      box-shadow: 0 0.3rem 0.8rem #25d36678;\n      &:hover\n      {\n        background-color: #128C7E;\n        box-shadow: 0 0.3rem 0.8rem #128C7E78;\n      }\n      &:active\n      {\n        background-color: #075E54;\n        box-shadow: 0 0.3rem 0.8rem #075E5478;\n      }\n\n      span\n      {\n        position: relative;\n        top: 2px;\n      }\n    }\n    &__ad\n    { \n      min-width: 180px;\n      width: 100%;\n      max-width: 220px;\n      padding: 10px 8px 10px 8px;\n      background-color: #128C7E;\n      border-radius: 5px;\n      overflow-y: auto;\n      height: 90vh;\n  \n      .ads-cards\n      {\n        border-radius: 5px;\n        max-height: calc(70vh - 155px);\n        overflow-y: auto;\n        &__card-ad\n        {\n          border-radius: 5px;\n          border: solid 1px #fff;\n          overflow: hidden;\n\n          &:not(:last-child)\n          {\n            margin-bottom: 8px;\n          }\n          img\n          {\n            width: 100%;\n            height: 155px;\n            object-fit: cover;\n          }\n\n          .card-ad__footer\n          {\n            a, \n            button\n            {\n              background-color: #075E54;\n              cursor: pointer;\n              color: #fff;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n.ads-cards[horizontal=\"horizontal\"]\n{\n  display: flex;\n  align-items: flex-end;\n  gap: 5px;\n  justify-content: center;\n  \n  .ads-cards__card-ad\n  {\n    width: auto;\n    border-radius: 5px;\n    img\n    {\n      width: 100%;\n      object-fit: contain;\n      height: 230px;\n      background-color: #000;\n      border: double 10px #f5e432;\n    }\n    .card-ad__footer\n    {\n      background-color: #000;\n      a\n      {\n        color: #fff;\n      }\n    }\n  }\n}\n.skeleton-home\n{\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px 5px;\n  align-items: center;\n  justify-content: center;\n\n  span\n  {\n    min-width: 250px;\n    max-width: 350px;\n    flex: 1;\n  }\n}\n\n.filter-search-order\n{\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 30px;\n  gap: 8px;\n  position: sticky;\n  top: 10px;\n  flex-wrap: wrap;\n  z-index: 5;\n\n  .input-search\n  {\n    flex: 1;\n  }\n  &__buttons\n  {\n    gap: 5px;\n\n    .icon_btn\n    {\n      display: flex;\n      transition: all .2s ease;\n      cursor: pointer;\n      align-items: center;\n      border: none;\n      transform: scale(1);\n      justify-content: center;\n      background-color: #fff;\n      color: #000;\n      box-shadow: 0 0.125rem 0.25rem #00000025;\n      height: 40px;\n      font-size: 15px;\n      width: 40px;\n      border-radius: 5px;\n      &:hover\n      {\n        background-color: $dark;\n        color: #fff;\n        transform: scale(.9);\n      }\n    }\n  }\n}\n.principalCarouselAndAd\n{\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: flex-start;\n  width: 100%;\n  height: calc(100vh / 2.1);\n  gap: 8px 8px;\n  z-index: 1;\n  @include mobile-half()\n  {\n    height: 280px;\n  }\n\n  &__slide\n  {\n    flex: 1 1;\n    z-index: 2;\n    background-color: #000;\n    height: calc(100vh / 2.1);\n    align-self: flex-start;\n    border-radius: 3px;\n    @include mobile-half()\n    {\n      height: 280px;\n    }\n    @include mobile\n    {\n      margin-bottom: 8px;\n    }\n\n    &__carousel\n    {\n      margin: 0 auto;\n      width: 100%;\n      height: inherit;\n\n      .carousel-inner,\n      .carousel-item\n      {\n        height: inherit;\n      }\n    }\n  }\n  &__ad\n  {\n    @include tablet()\n    {\n      display: none;\n    }\n    @media screen and (min-width: 1445px)\n    {\n      min-width: calc(100vw / 5);\n    }\n    width: 300px;\n    height: inherit;\n    max-width: 512px;\n    background-color: #000;\n    border: double 8px #f5e432;\n\n    img\n    {\n      object-fit: cover;\n      width: 100%;\n      height: 100%;\n    }\n  }\n}\n.footerPage \n{\n  background-color: #e8e8e8;\n  padding: 1em;\n  margin-top: 4em;\n  position: relative;\n  padding-top: 100px;\n\n  .custom-shape-divider-top-1656462391 \n  {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    overflow: hidden;\n    line-height: 0;\n\n    .shape-fill \n    {\n      fill: #FFFFFF;\n    }\n    svg \n    {\n      position: relative;\n      display: block;\n      width: calc(100% + 1.3px);\n      height: 90px;\n    }\n  }\n  &__ul\n  {\n    li\n    {\n      margin-bottom: 8px;\n    }\n  }\n}\n.footer__line-bottom\n{\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: #2d572c;\n  width: 100%;\n  padding: 8px 8px;\n  font-size: 11px;\n  font-weight: 300;\n  color: #fff;\n  flex-wrap: wrap;\n  gap: 0px 12px;\n\n  @include mobile()\n  {\n    justify-content: center;\n  }\n\n  & > span\n  {\n    min-width: fit-content;\n    font-weight: 500;\n  }\n  &__links\n  {\n    position: relative;\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n    grid-gap: 0px 12px;\n    gap: 0px 12px;\n    flex-direction: column;\n    &:after\n    {\n      content: '';\n      background: #ababab;\n      position: absolute;\n      top: 50%;\n      width: 1px;\n      height: 100%;\n      transform: translateY(-50%);\n      left: -10px;\n    }\n    a\n    {\n      position: relative;\n      min-width: fit-content;\n      line-height: 18px;\n    }\n    span\n    {\n      color: #7d7d7d;\n      text-decoration: underline;\n    }\n  }\n}\n\n.carousel-principal-text\n{\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 45px;\n  line-height: 30px;\n  backdrop-filter: blur(8px);\n  z-index: 1;\n  width: 100%;\n  height: auto;\n  padding: 8px 2px;\n  p\n  {\n    color: #000;\n    font-size: 20px;\n    font-weight: 500;\n\n    &:not(.--principal)\n    {\n      @include mobile()\n      {\n        display: none;\n      }\n    }\n\n    &.--principal\n    {\n      font-size: clamp(1rem, 5vw, 2.3rem);\n      color: $primary;\n      font-weight: 900;\n      text-shadow:  0px 1px 0px #fff, \n                    0px -1px 0px #fff, \n                    -1px 0px 0px #fff, \n                    1px 0px 0px #fff;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
